import React, { forwardRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/product.css";
import ImageSlider from "./ImageSlider";
import { Utils } from "../services/Utils";
import { IMedia, IProduct } from "../types/Product"
import SkeletonLoader from "./Loader/SkeletonLoader";
import Image from "./Image/Image";
// Define the product type
interface ProductProps {
    product: IProduct;
}



let imgSlide: any = [
];

const Product = forwardRef<HTMLAnchorElement, ProductProps>((props: ProductProps, ref) => {
    const [isImageLoaded, setIsImageLoaded] = useState(Boolean(false));
    const afterImageLoad = () => {
        setIsImageLoaded(true);
    };

    const product: IProduct = props.product
    const productImg = product.media?.at(0)?.url;
    imgSlide = product.media?.map((item) => ({
        "image_url": item.url,
        "title": product.name
    }));

    return (
        <Link ref={ref}
            className="product-item column is-one-fifth is-two-fifths-mobile"
            key={product.id}
            to={`/products/${Utils.getHyphenatedString(product.name)}`}
        >
            <div className="product-mask">
                <div className="product-hover-slider">
                    <ImageSlider products={imgSlide} />
                </div>
                {isImageLoaded ? <div className="bottom-right">Best Sellers</div> : ""}
                {isImageLoaded ? <div className="top-right">30% Off</div> : ""}
                <figure className={`mb-2 image is-4by5 `}>
                    <Image
                        src={productImg}
                        alt={product.name}
                        className="product-image"
                        loading="lazy"
                        onImageLoad={afterImageLoad}
                    />
                    {!isImageLoaded ? <SkeletonLoader lines={3} circles={0} width="80%" height="18px" circleSize="10px" /> : ""}
                </figure>

            </div>



            <div className="product-productMetaInfo">
                <div className="product-metainfo-hover">
                    <div className="product-wishlist-button">
                        {/* <button className="button primary-button"><span className="material-symbols-outlined">favorite</span> &nbsp; WISHLIST</button> */}
                    </div>
                </div>
                <h3 className="product-brand">{product.name}</h3>
                <h4 className="product-product">{product.shortDescription}</h4>
                <div className="product-price">
                    <span>
                        <span className="product-discountedPrice">
                            {Utils.formatCurrency((product.price))}
                        </span>
                        <span className="product-strike">{product.compareAtPrice ? Utils.formatCurrency(product.compareAtPrice) : ''}</span>
                    </span>
                    <span className="product-discountPercentage"></span>
                </div>


            </div>
        </Link>
    );
});

export default Product;
